"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OldLinkBannerMobile = require("./OldLinkBannerMobile");
Object.keys(_OldLinkBannerMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldLinkBannerMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldLinkBannerMobile[key];
    }
  });
});